/**
 * Schema of Alerta
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import Alerta from '@/model/resource/Alerta'

export default (model: Alerta): Schema => ({
  idAlertaPk: {
    content: model.idAlertaPk,
    editable: false,
  },

  descricao: {
    content: model.descricao,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  idResponsavelFk: {
    content: model.idResponsavelFk,
    input: InputType.TEXT,
  },

  ativo: {
    content: bool(model.ativo),
    input: InputType.CHECKBOX,
  },
})
